"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generalValidateToken = exports.generalValidatePassword = exports.generalUniqueAccess = exports.generalSuccess = exports.generalSavePassword = exports.generalResetPasswordCommonReset = exports.generalResetPassword = exports.generalReset = exports.generalForgotPassword = exports.generalError = exports.generalChangeStatus = void 0;
var _general = require("./general.constant");
// common success
var generalSuccess = function generalSuccess(actionType, data) {
  return {
    type: _general.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.generalSuccess = generalSuccess;
var generalError = function generalError(actionType, error) {
  return {
    type: _general.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * Reset password
 * @param payload
 * @returns api response
 * @description this function used to reset passworld its credencials.
 */
exports.generalError = generalError;
var generalResetPassword = function generalResetPassword(data) {
  return {
    type: _general.actionTypes.RESET_PASSWORD,
    payload: data
  };
};

/**
 * Reset password common reset
 * @param payload
 * @returns api response
 * @description this function used to reset passworld its credencials.
 */
exports.generalResetPassword = generalResetPassword;
var generalResetPasswordCommonReset = function generalResetPasswordCommonReset() {
  return {
    type: _general.actionTypes.RESET_PASSWORD_COMMON_RESET
  };
};

/**
 * Change status
 * @param payload
 * @returns api response
 * @description this function used to change status.
 */
exports.generalResetPasswordCommonReset = generalResetPasswordCommonReset;
var generalChangeStatus = function generalChangeStatus(data) {
  return {
    type: _general.actionTypes.CHANGE_STATUS,
    payload: data
  };
};

/**
 * Forgot password
 * @param payload
 * @returns api response
 * @description this function used to request for forgot password.
 */
exports.generalChangeStatus = generalChangeStatus;
var generalForgotPassword = function generalForgotPassword(data) {
  return {
    type: _general.actionTypes.FORGOT_PASSWORD,
    payload: data
  };
};

/**
 * save password
 * @param payload
 * @returns api response
 * @description this function used to request for save password.
 */
exports.generalForgotPassword = generalForgotPassword;
var generalSavePassword = function generalSavePassword(data) {
  return {
    type: _general.actionTypes.SAVE_PASSWORD,
    payload: data
  };
};

/**
 * Unique access
 * @param payload
 * @returns api response
 * @description this function used to unique request.
 */
exports.generalSavePassword = generalSavePassword;
var generalUniqueAccess = function generalUniqueAccess(data) {
  return {
    type: _general.actionTypes.UNIQUE_ACCESS,
    payload: data
  };
};

/**
 * Validate password
 * @param payload
 * @returns api response
 * @description this function used to validate password.
 */
exports.generalUniqueAccess = generalUniqueAccess;
var generalValidatePassword = function generalValidatePassword(data) {
  return {
    type: _general.actionTypes.VALIDATE_PASSWORD,
    payload: data
  };
};

/**
 * Validate token
 * @param payload
 * @returns api response
 * @description this function used to check validated token.
 */
exports.generalValidatePassword = generalValidatePassword;
var generalValidateToken = function generalValidateToken(data) {
  return {
    type: _general.actionTypes.VALIDATE_TOKEN,
    payload: data
  };
};

/**
 * Reset general
 * @param payload
 * @returns api response
 * @description this function used to reset general.
 */
exports.generalValidateToken = generalValidateToken;
var generalReset = function generalReset() {
  return {
    type: _general.actionTypes.RESET
  };
};
exports.generalReset = generalReset;